import { type Messages } from ".";

export const messagesNL: Messages = {
  HOME: {
    TITLE: "Dashboard",
    ROUTE: "/dashboard",
    PAGE: "Welkom bij Mithril App",
    INTRO:
      "Een krachtige single-page applicatie gebouwd met Mithril.js en TypeScript",
    SECTION1_TITLE: "Functies",
    SECTION1:
      "Deze applicatie toont moderne webontwikkeling met Mithril.js, met reactieve statusbeheer, ondersteuning voor internationalisatie en een modulaire componentarchitectuur.",
    SECTION2_TITLE: "Technologie Stack",
    SECTION2:
      "Gebouwd met TypeScript voor typeveiligheid, Rspack voor snelle builds en Materialize CSS voor een responsieve gebruikersinterface. Het Meisis pattern zorgt voor voorspelbare statustransities.",
    SECTION3_TITLE: "Gebruik",
    SECTION3:
      "Navigeer door de secties met de navigatiebalk. Gebruik de zoekfunctie om content te vinden op alle pagina s. Wissel talen om de internationalisatiefuncties te ervaren.",
  },
  ABOUT: {
    TITLE: "Over de app",
    ROUTE: "/over",
    PAGE: "Over Mithril App",
    INTRO: "Leer meer over deze Mithril.js applicatie en haar ontwikkeling",
    SECTION1_TITLE: "Wat is Mithril.js",
    SECTION1:
      "Mithril is een moderne client-side JavaScript framework voor het bouwen van krachtige single-page applicaties. Het biedt een compacte API, virtual DOM implementatie en routing out of the box.",
    SECTION2_TITLE: "Belangrijkste Functies",
    SECTION2:
      "Deze applicatie toont Mithril capaciteiten inclusief reactieve statusbeheer, internationalisatie, type-veilige TypeScript ontwikkeling en modulaire component architectuur.",
    SECTION3_TITLE: "Ontwikkelingsdoelstellingen",
    SECTION3:
      "Het doel van dit project is om een schone, onderhouwbare codebase te bieden die moderne webontwikkelings patronen toont met Mithril.js als alternatief voor zwaardere frameworks.",
  },
  SETTINGS: {
    TITLE: "Instellingen",
    ROUTE: "/instellingen",
    PAGE: "Applicatie Instellingen",
    INTRO: "Configureer uw applicatievoorkeuren en taalinstellingen",
    SECTION1_TITLE: "Taal Voorkeuren",
    SECTION1:
      "Wissel tussen Engels en Nederlands. Uw voorkeur wordt opgeslagen in localStorage en blijft geldig voor alle sessies.",
    SECTION2_TITLE: "Thema Instellingen",
    SECTION2:
      "Pas de visuele opmaak van de applicatie aan. Pas kleuren, lettertypen en lay-outvoorkeuren aan om ze aan uw werkstroom te matchen.",
    SECTION3_TITLE: "Voorkeuren",
    SECTION3:
      "Beheer applicatiegedrag inclusief standaardweergaven, data persistentie opties en meldingsinstellingen.",
  },
  LANDING: { TITLE: "Introductie", ROUTE: "/" },
  HAZARDS: { TITLE: "Gevaren", ROUTE: "/gevaren" },
  SOLUTIONS: { TITLE: "Oplossingen", ROUTE: "/oplossingen" },
  ROADMAP: { TITLE: "Routekaart", ROUTE: "/routekaart" },
  USER: "Gebruiker",
  EDITOR: "Editor",
  ADMIN: "Administrator",
  CANCEL: "Afbreken",
  DELETE: "Verwijderen",
  YES: "Ja",
  NO: "Nee",
  OK: "Ok",
  NAME: "Naam",
  DESCRIPTION: "Omschrijving",
  DELETE_ITEM: {
    TITLE: "Verwijder {item}",
    DESCRIPTION:
      "Weet u zeker dat u de {item} wilt verwijderen? Dit kan niet ongedaan gemaakt worden.",
  },
  SAVE_BUTTON: {
    LABEL: "Opslaan",
    TOOLTIP: "Sla aanpassingen op",
  },
  SEARCH: "Zoek...",
  SEARCH_TOOLTIP: "Type / om te zoeken",
  LANGUAGE: "Taal",
  CLEAR: "Wis model",
  UPLOAD: "Lees model in als JSON",
  DOWNLOAD: "Sla model op als JSON",
  PERMALINK: "Maak link",
  ROLE: "Rol",
  LINK: "Link",
  MODEL: "Model",
  TITLE: "Titel",
  AUTHORS: "Auteurs",
  TYPE: "Type",
  HITS: {
    n: "{n} Hits",
  },
  NO_RESULTS: "Geen resultaten gevonden",
  CLEAR_SEARCH: "Zoekopdracht wissen",
  PAGE_NOT_FOUND: "Pagina niet gevonden",

  about_route: "/over",
  about: "Over",
  acronym: "Acroniem",
  add_term: "Voeg een nieuwe term toe",
  addr_how: "Hoe wordt het aangepakt?",
  addressed: "Aangepakt",
  ass_instr:
    "_Beoordeel de capaciteit op basis van haar belang voor het realiseren van de gedefinieerde doelstellingen en de huidige prestaties en geef eventuele verbeterpunten aan._",
  ass_label: "Oorzaak probleem bekend?",
  ass_overall: "Noodzaak verbetering capaciteit",
  ass_scale: "Schaal voor beoordelingsscore",
  ass_setting: "Beoordelingsmatrix",
  ass: "Beoordeling",
  assess_content:
    "Beoordeel de capaciteit op basis van haar belang voor het realiseren van de gedefinieerde doelstellingen en de huidige prestaties en geef eventuele verbeterpunten aan. Begin met het selecteren van een capaciteit.",
  assess: "Beoordelen",
  assessment_route: "/beoordeling/:id",
  assessment: "Beoordeling",
  avg_perf: "Status capaciteit",
  cap_cat: "Hoofdcategorie",
  cap: "Capaciteit",
  caps: "Capaciteiten",
  cat: "Categorie",
  clear_all: "Wis alle filters",
  clear: "Wissen",
  color: "Kleur",
  create_cap: "Capaciteit",
  defs: "Definities",
  del_model: "Wilt u echt alles wissen?",
  del_model_desc: "Weet u zeker dat u het model wilt weggooien?",
  del_proj: "Verwijder project",
  desc_cap_instr: "Beschrijf de capaciteit in detail.",
  desc: "Toelichting",
  develop_content:
    "Begin met het ontwikkelen van capaciteiten, alleen of samen met andere organisaties, en maak een routekaart.",
  develop: "Ontwikkelen",
  development: "Ontwikkeling",
  development_route: "/ontwikkeling/:id",
  dev_cap:
    "Stel nieuwe projecten voor om capaciteit te ontwikkelen. Begin met het selecteren van een capaciteit.",
  doc_id: "Document-ID",
  doc: "Documentatie",
  download: "Downloaden",
  duration: "Duur",
  edit: "Bewerken",
  view: "Bekijken",
  evaluation_route: "/evaluatie/:id",
  evaluation: "Evaluatie",
  exp_perf: "Verwachte prestaties",
  expl: "Toelichting",
  expl2: "Prestatie",
  filter_cap: "Filter capaciteiten",
  filter_caps: "Filter capaciteiten",
  filter_ph: "Deel van titel of beschrijving...",
  filter_text_ph: "Deel van term of beschrijving...",
  filter_text: "Filter tekst",
  filters: "Filters",
  relevance: "Relevant",
  gap_scale: "Schaalindeling voor typering van gaps",
  gap_settings: "##### Instellingen voor gaps",
  gap: "Aard problematiek",
  gaps_common: "Veelvoorkomende gaps of oorzaken van problemen",
  gaps: "Probleemtypering",
  gng: "###### GO / NO GO beslissing<br>",
  go: "GO",
  goal_scale: "Optie",
  goals_instr: "Specificeer langetermijn- en kortetermijndoelen",
  goal: "Doelstelling",
  goals: "Doelstellingen",
  group_goals_instr:
    "1. **Specificeer de belangrijkste doelstellingen binnen de betreffende context.**\n2. Specificeer betrokken organisaties en hun rol binnen de betreffende context.\n3. Specificeer de hoofd- en subcategorieën van capaciteiten (1ste en 2de niveau).\n4. Specificeer relevante capaciteiten binnen alle subcategorieën (3de niveau).",
  group_goals: "Doelstellingen",
  home_route: "/",
  home: "STARTPAGINA",
  id: "ID",
  importance: "Belang",
  in_months: "In maanden",
  loc: "Fysieke locatie",
  main_goals: "Doelstellingen",
  assess_capability_importance_for_capability:
    'Beoordeel het belang van "{capability}" voor de gekozen scope.',
  max_imp: "Belang capaciteit",
  name: "Naam",
  no_go: "NO GO",
  no: "Nee",
  org_dept: "Organisatie / afdeling",
  overview_route: "/overzicht",
  overview: "Overzicht",
  level: "Niveau",
  perf_asp: "Prestatieaspect",
  perf_asps: "Prestatieaspecten",
  assess_performance_aspects_for_capability:
    "Beoordeel de prestatieaspecten van {capability}.",
  perf_effectiveness_tooltip: "Hoe effectief is {capability}?",
  perf_safety_professionals_tooltip:
    "Wat is het niveau van de fysieke en mentale veiligheid van operationeel personeel dat werkt aan {capability}?",
  perf_efficiency_tooltip: "Hoe efficiënt is {capability}?",
  perf_scale: "Schaal voor prestatiescore",
  perf_settings:
    "##### Aanduiding van de status (prestaties) van een capaciteit",
  perf: "Prestatiecriteria",
  period: "JJJJ Kw1 of JJJJ M1",
  permalink: "Permalink",
  pers_inv: "Betrokken personen",
  pick_more: "Kies één of meer",
  pick_one: "Kies één",
  prep_content:
    "Stel de capaciteiten vast die binnen de context van de problematiek relevant zijn.",
  preparation_route: "/capaciteiten",
  preparation: "Capaciteiten",
  prepare_content:
    "Stel de capaciteiten vast die binnen de context van de problematiek relevant zijn.",
  prepare: "Voorbereiden",
  prob_areas: "Probleemgebieden",
  gap_problem_categories_intro:
    "Analyseer deze capaciteitskloof op de volgende probleemcategorieën.",
  gap_likert_severity: "Ernst",
  gap_likert_severity_start_label: "Zeer laag",
  gap_likert_severity_middle_label: "Gemiddeld",
  gap_likert_severity_end_label: "Zeer hoog",
  gap_likert_probability: "Waarschijnlijkheid",
  gap_likert_probability_start_label: "Geen verandering",
  gap_likert_probability_middle_label: "—",
  gap_likert_probability_end_label: "Grote afname",
  gap_likert_impact: "Impact",
  gap_likert_impact_start_label: "Geen verandering",
  gap_likert_impact_middle_label: "—",
  gap_likert_impact_end_label: "Grote afname",
  gap_likert_severity_tooltip:
    "Hoe beoordeelt u de ernst van deze capaciteitskloof?",
  gap_likert_probability_tooltip:
    "Stel dat de kloof is opgelost: wat zou dit betekenen voor de kans op het optreden van de kloof?",
  gap_likert_impact_tooltip:
    "Stel dat de kloof is opgelost. Wat zou dit betekenen voor de vermindering van de impact van de oorspronkelijke kloof?",
  prob: "Probleem",
  proj_app: "###### GOEDKEURING<br>",
  proj_name: "Projectnaam",
  proj_prop: "Nieuw project of voorstel",
  proj_sum: "Projectsamenvatting",
  prop_name: "Voorstelnaam",
  prop_new: "Nieuw voorstel",
  ref: "Referentie",
  ref_url: "Referentie URL",
  select_cap: "Selecteer capaciteit",
  select_cat: "Selecteer hoofdcategorie",
  select_m_ph: "Selecteer één of meer",
  select_subcat: "Selecteer subcategorie",
  settings_route: "/instellingen",
  settings: "Instellingen",
  sh_filter: "Filter betrokken organisaties",
  sh_org: "Betrokken organisaties",
  sh_settings: "##### Betrokken organisaties",
  sh_type: "Type organisatie of instelling",
  sh_types: "Typen organisaties",
  sh: "Betrokken organisatie",
  shs: "Betrokken organisaties",
  other_stakeholder: "Beschrijf de andere betrokkene",
  spec_cap_instr:
    "1. Specificeer de belangrijkste doelstellingen binnen de betreffende context.\n2. Specificeer betrokken organisaties en hun rol binnen de betreffende context.\n3. Specificeer de hoofd- en subcategorieën van capaciteiten (1ste en 2de niveau).\n4. **Specificeer relevante capaciteiten binnen alle subcategorieën (3de niveau).**",
  spec_cap: "Capaciteiten",
  spec_cat_instr:
    "1. Specificeer de belangrijkste doelstellingen binnen de betreffende context.\n2. Specificeer betrokken organisaties en hun rol binnen de betreffende context.\n3. **Specificeer de hoofd- en subcategorieën van capaciteiten (1ste en 2de niveau).**\n4. Specificeer relevante capaciteiten binnen alle subcategorieën (3de niveau).",
  spec_cat: "Categorieën",
  spec_sh_instr:
    "1. Specificeer de belangrijkste doelstellingen binnen de betreffende context.\n2. **Specificeer betrokken organisaties en hun rol binnen de betreffende context.**\n3. Specificeer de hoofd- en subcategorieën van capaciteiten (1ste en 2de niveau).\n4. Specificeer relevante capaciteiten binnen alle subcategorieën (3de niveau).",
  spec_sh: "Betrokken organisaties",
  start_time: "Starttijd",
  subcat: "Subcategorie",
  task_settings: "##### Schaalindeling voor mate van belang",
  task: "Prestatiecriterium",
  task2perf: "##### Vaststellen noodzaak tot verbetering capaciteiten",
  tasks: "Typering belang",
  ass_task_scale: "Belang",
  ass_perf_scale: "Status",
  taxonomy_route: "/taxonomie",
  taxonomy: "Taxonomie",
  tax_def: "#### Taxonomie\n\nBetekenis van gebruikte begrippen.",
  TAXONOMY: {
    HAZARD: "Gevaar",
    HAZARD_DEF:
      "Een proces, fenomeen of menselijke activiteit die levensverlies, letsel, ontwrichting of milieuschade kan veroorzaken.",
    HAZARD_TYPE: "Gevarentype",
    HAZARD_TYPE_DEF:
      "Een klasse van gevaren met vergelijkbare oorsprong of kenmerken, zoals natuurlijke, technologische of door mensen veroorzaakte gevaren.",
    DISASTER: "Ramp",
    DISASTER_DEF:
      "Een ernstige verstoring van een gemeenschap of samenleving die de eigen veerkracht en middelen overstijgt.",
    EMERGENCY: "Noodsituatie",
    EMERGENCY_DEF:
      "Een situatie die onmiddellijke, gecoordineerde actie vereist om leven, gezondheid, eigendom of milieu te beschermen.",
    DISASTER_RISK: "Rampenrisico",
    DISASTER_RISK_DEF:
      "De potentiële schade door gevaarlijke gebeurtenissen, bepaald door gevaar, blootstelling, kwetsbaarheid en capaciteit.",
    EXPOSURE: "Blootstelling",
    EXPOSURE_DEF:
      "De aanwezigheid van mensen, middelen, infrastructuur en diensten op locaties waar gevaren zich kunnen voordoen.",
    VULNERABILITY: "Kwetsbaarheid",
    VULNERABILITY_DEF:
      "Omstandigheden die de gevoeligheid van mensen, middelen of systemen voor de impact van gevaren vergroten.",
    CAPACITY: "Capaciteit",
    CAPACITY_DEF:
      "De sterktes en middelen die beschikbaar zijn om gevaren te voorzien, op te vangen, te weerstaan en ervan te herstellen.",
    CAPABILITY: "Operationele capaciteit",
    CAPABILITY_DEF:
      "Een specifieke, aantoonbare bekwaamheid van een organisatie om onder bepaalde voorwaarden taken uit te voeren en resultaten te behalen.",
    RESILIENCE: "Veerkracht",
    RESILIENCE_DEF:
      "Het vermogen van systemen en gemeenschappen om te weerstaan, op te vangen, zich aan te passen en tijdig te herstellen met behoud van essentiële functies.",
    PREVENTION: "Preventie",
    PREVENTION_DEF:
      "Maatregelen om het ontstaan van nieuwe risico's te voorkomen en schadelijke gevolgen van gevaren te vermijden.",
    MITIGATION: "Mitigatie",
    MITIGATION_DEF:
      "Maatregelen die de ernst of waarschijnlijkheid van negatieve effecten van gevaarlijke gebeurtenissen verminderen.",
    PREPAREDNESS: "Voorbereidheid",
    PREPAREDNESS_DEF:
      "Kennis, plannen en capaciteiten die vooraf worden ontwikkeld om effectief te kunnen anticiperen, reageren en herstellen.",
    EARLY_WARNING_SYSTEM: "Vroegtijdig waarschuwingssysteem",
    EARLY_WARNING_SYSTEM_DEF:
      "Een geïntegreerd systeem voor gevarenmonitoring, risico-inschatting, waarschuwing en tijdig handelen.",
    RESPONSE: "Respons",
    RESPONSE_DEF:
      "Acties vlak voor, tijdens of direct na een gebeurtenis om levens te redden en in acute behoeften te voorzien.",
    RECOVERY: "Herstel",
    RECOVERY_DEF:
      "Het proces van herstel en verbetering van bestaanszekerheid, diensten, infrastructuur en systemen na een ramp.",
    BUILD_BACK_BETTER: "Beter terugbouwen",
    BUILD_BACK_BETTER_DEF:
      "Herstel en wederopbouw gebruiken om toekomstige risico's te verminderen en de veerkracht te vergroten.",
    CONTINGENCY_PLANNING: "Scenario- en noodplanning",
    CONTINGENCY_PLANNING_DEF:
      "Het vooraf uitwerken van operationele plannen en samenwerkingsafspraken voor plausibele noodscenario's.",
    RISK_ASSESSMENT: "Risicobeoordeling",
    RISK_ASSESSMENT_DEF:
      "Een gestructureerd proces om gevaren te identificeren, gevolgen te analyseren en risico's in te schatten ter ondersteuning van besluitvorming.",
    RISK_COMMUNICATION: "Risicocommunicatie",
    RISK_COMMUNICATION_DEF:
      "Tweerichtingsuitwisseling van risico-informatie tussen autoriteiten, responders, stakeholders en publiek.",
    SITUATION_AWARENESS: "Situatiebewustzijn",
    SITUATION_AWARENESS_DEF:
      "Een actueel en gedeeld beeld van incidentomstandigheden, impact, beschikbare middelen en te verwachten ontwikkelingen.",
    INCIDENT_COMMAND: "Incidentcommandovoering",
    INCIDENT_COMMAND_DEF:
      "Een commandostructuur voor de organisatie van rollen, besluiten en middelen tijdens incidenten.",
    STAKEHOLDER: "Stakeholder",
    STAKEHOLDER_DEF:
      "Elke organisatie, groep of persoon met een rol, verantwoordelijkheid of belang in voorbereiding, respons of herstel.",
    INTEROPERABILITY: "Interoperabiliteit",
    INTEROPERABILITY_DEF:
      "Het vermogen van organisaties, teams en systemen om effectief samen te werken over procedures, data en technologie heen.",
    CAPABILITY_GAP: "Capaciteitstekort",
    CAPABILITY_GAP_DEF:
      "Het verschil tussen de vereiste en de huidige capaciteit om beoogde resultaten te behalen.",
    CAPABILITY_ASSESSMENT: "Capaciteitsbeoordeling",
    CAPABILITY_ASSESSMENT_DEF:
      "Een gestructureerde evaluatie van belang en prestatie van capaciteiten om verbeterprioriteiten te bepalen.",
    SOLUTION: "Oplossing",
    SOLUTION_DEF:
      "Een maatregel, werkwijze, technologie of interventie om een of meer capaciteitstekorten aan te pakken.",
    SOLUTION_ASSESSMENT: "Oplossingsbeoordeling",
    SOLUTION_ASSESSMENT_DEF:
      "Een systematische beoordeling van oplossingen op gebruikersbehoeften, operationele toepasbaarheid, impact en compliance.",
    ROADMAP: "Routekaart",
    ROADMAP_DEF:
      "Een gefaseerd implementatieplan dat laat zien wat wanneer en door wie wordt gerealiseerd.",
    IMPLEMENTATION_TIMELINE: "Implementatietijdlijn",
    IMPLEMENTATION_TIMELINE_DEF:
      "De geplande volgorde en timing van activiteiten, mijlpalen en opleveringen voor implementatie.",
    PRIORITIZATION: "Prioritering",
    PRIORITIZATION_DEF:
      "Het rangschikken van acties of investeringen op basis van urgentie, impact, haalbaarheid en beschikbare middelen.",
    MONITORING_EVALUATION: "Monitoring en evaluatie",
    MONITORING_EVALUATION_DEF:
      "Doorlopende opvolging en periodieke beoordeling van voortgang, resultaten en effectiviteit voor leren en bijsturing.",
    LESSONS_LEARNED: "Lessen geleerd",
    LESSONS_LEARNED_DEF:
      "Gedocumenteerde inzichten uit operaties en oefeningen die toekomstige planning en uitvoering verbeteren.",
    SESSION: "Beoordelingssessie",
    SESSION_DEF:
      "Een opgeslagen werkcontext met geselecteerde gevaren, beoordelingen, oplossingen en routekaartgegevens.",
    COMPLIANCE_CHECK: "Compliancecontrole",
    COMPLIANCE_CHECK_DEF:
      "Een verificatie dat voorgestelde oplossingen en acties voldoen aan wetgeving, beleid, ethische en sectorspecifieke eisen.",
    TECHNOLOGY_READINESS_LEVEL: "Technologisch gereedheidsniveau",
    TECHNOLOGY_READINESS_LEVEL_DEF:
      "Een schaal van 1 tot 9 die de volwassenheid van een technologie aangeeft, van concept tot operationele inzet.",
  },
  term: "Begrip",
  title: "Titel",
  upload: "Uploaden",
  url: "URL",
  value: "Waarde",
  yes: "Ja",
  TBD: "Onbekend",
  general_settings: "Algemeen",
  enable_sol_ass_support: "Activeer oplossingsondersteuning",
  logo: "Gebruikerslogo",
  attribution_logo: "Attributie logo",
  attribution_text: "Attributie tekst",
  order: "Volgorde",
  hide: "Verberg in overzicht",
  select_user: "Selecteer gebruiker",
  user: "Reguliere gebruiker",
  moderator: "Moderator",
  doc_title: "Capability Assessment Report",
  export_to_word: "Exporteer naar Word",
  export_all_to_word: "Exporteer volledig rapport naar Word",
  admin: "Administrator",
  ignore: "Niet van toepassing",
  add_gap: "Voeg tekortkoming toe",
  continue: "Ga verder",
  hazards: "Gevaren",
  hazards_route: "/gevaren",
  hazard_step_title: "0: Initiatie & Voorbereiding",
  hazard_step_desc:
    "Selecteer de gevarentypen die relevant zijn voor het bereik dat u in dit beoordelingsworkshop wilt behandelen.",
  workshop_scope: "Workshop bereik",
  hazard_category_all: "Alle",
  hazard_category_natural: "Natuurlijk",
  hazard_category_technical: "Technisch",
  hazard_category_attack: "Aanslag",
  hazard_edit: "Bewerk gevarentypen",
  hazard_done: "Klaar met bewerken",
  hazard_add: "Nieuw gevarentype toevoegen",
  hazard_name: "Naam gevaar",
  hazard_description: "Beschrijving / context",
  hazard_selected_count: "{n} gevarentype(n) geselecteerd.",
  solutions: "Oplossingen",
  solution_count: {
    1: "1 oplossing",
    n: "{n} oplossingen",
  },
  solutions_route: "/oplossingen",
  solutions_step_title: "Stap 2: Oplossingsbeoordeling",
  solutions_step_desc:
    "Voeg oplossingen toe en beoordeel ze voor geïdentificeerde capaciteitstekorten.",
  solution_add: "Oplossing toevoegen",
  solution_new: "Nieuwe oplossing",
  solution_gaps_found: {
    1: "1 capaciteitstekort geïdentificeerd",
    n: "{n} capaciteitstekorten geïdentificeerd",
  },
  solution_empty:
    "Nog geen oplossingen toegevoegd. Klik op 'Oplossing toevoegen' om te starten.",
  roadmap: "Routekaarten",
  roadmap_count: {
    1: "1 routekaart",
    n: "{n} routekaarten",
  },
  roadmap_route: "/routekaart",
  roadmap_step_title: "Stap 3: Routekaart",
  roadmap_step_desc:
    "Plan implementatietijdlijnen en toezeggingen voor uw geselecteerde oplossingen.",
  roadmap_add_solutions: "Voeg {n} oplossing(en) toe aan routekaart",
  roadmap_empty_solutions:
    "Voltooi stap 3 (Oplossingsbeoordeling) eerst om oplossingen aan de routekaart toe te voegen.",
  roadmap_empty: "Nog geen routekaartitems.",
  roadmap_timeline: "Tijdlijn",
  session_create: "Aanmaken",
  session_new_name: "Naam nieuwe sessie",
  session_sessions: "Beoordelingssessies",
  session_name: "Naam",
  session_updated: "Laatst bijgewerkt",
  session_actions: "Acties",
  session_clone: "Sessie klonen",
  session_download: "Downloaden als JSON",
  session_delete: "Sessie verwijderen",
  session_import: "JSON importeren",
  session_delete_confirm: "Sessie verwijderen: {name}?",
  session_delete_warning:
    "Dit kan niet ongedaan worden gemaakt. Weet u het zeker?",
  dashboard_subtitle:
    "Volg de onderstaande stappen om uw rampenbestrijdingsbeoordeling te voltooien.",
  back_to_sessions: "Terug naar sessies",
  step0_title: "Initiatie & Voorbereiding",
  step1_title: "Behoeften & Lacunes Beoordeling",
  step2_title: "Oplossingsbeoordeling",
  step3_title: "Routekaart",
  summary: "Samenvatting",
  selected_hazards: "Geselecteerde gevaren",
  capability_gaps: "Capaciteitstekorten",
  more: "meer",
  partially: "Gedeeltelijk",
  not_assessed: "Niet beoordeeld",
  enabled_steps: "Actieve stappen",
  priority_low: "Laag",
  priority_medium: "Middel",
  priority_high: "Hoog",
  sol_trl: "Technologisch Gereedheidsniveau",
  trl1: "Basisprincipes waargenomen",
  trl2: "Technologieconcept geformuleerd",
  trl3: "Experimenteel bewijs van concept",
  trl4: "Technologie gevalideerd in laboratorium",
  trl5: "Technologie gevalideerd in relevante omgeving",
  trl6: "Technologie gedemonstreerd in relevante omgeving",
  trl7: "Systeemprototype gedemonstreerd in operationele omgeving",
  trl8: "Systeem volledig en gekwalificeerd",
  trl9: "Daadwerkelijk systeem bewezen in operationele omgeving",
  sol_integration_rl: "Integratiegereedheidsniveau",
  sol_societal_rl: "Maatschappelijk gereedheidsniveau",
  sol_manufacturing_rl: "Productiegereedheidsniveau",
  sol_commercialisation_rl: "Commercialiseringsgereedheidsniveau",
  sol_security_rl: "Beveiligingsgereedheidsniveau",
  sol_legal_privacy_ethical_rl:
    "Juridisch, privacy- en ethisch gereedheidsniveau",
  integration_rl1:
    "Er is een concept op hoofdlijnen voor integratie geïdentificeerd",
  integration_rl2:
    "Er is enige mate van specificatie van de eisen voor de interactie tussen componenten",
  integration_rl3:
    "Het gedetailleerde integratieontwerp is gedefinieerd en omvat alle interfacedetails",
  integration_rl4:
    "Validatie van integrerende componentfuncties in een laboratoriumomgeving",
  integration_rl5:
    "Validatie van integrerende componenten in een relevante omgeving",
  integration_rl6:
    "Validatie van integrerende componenten in een relevante end-to-end-omgeving",
  integration_rl7:
    "Demonstratie van prototype-integratie in een operationele omgeving met hoge getrouwheid",
  integration_rl8: "Test en demonstratie in een operationele omgeving",
  integration_rl9:
    "Bewezen systeemintegratie door succesvolle operationele missiecapaciteiten",
  societal_rl1:
    "Identificatie van de algemene maatschappelijke behoefte, het maatschappelijk nut en de bijbehorende aspecten",
  societal_rl2:
    "Formulering van het voorgestelde oplossingsconcept en de mogelijke effecten",
  societal_rl3:
    "Een beperkte groep in de samenleving kent de oplossing of vergelijkbare initiatieven",
  societal_rl4:
    "Een beperkte groep in de samenleving test de oplossing of vergelijkbare initiatieven",
  societal_rl5:
    "De samenleving kent de oplossing of vergelijkbare initiatieven, maar is zich niet bewust van de voordelen ervan",
  societal_rl6:
    "De samenleving kent de oplossing en het bewustzijn van de voordelen neemt toe",
  societal_rl7:
    "De samenleving is volledig op de hoogte van de voordelen van de oplossing",
  societal_rl8:
    "De samenleving is klaar om de oplossing te adopteren en heeft vergelijkbare oplossingen op de markt gebruikt",
  societal_rl9:
    "De samenleving gebruikt de oplossing en deze wordt ondersteund door belanghebbenden en het publiek",
  manufacturing_rl1: "Basale productie-implicaties geïdentificeerd",
  manufacturing_rl2: "Productieconcepten geïdentificeerd",
  manufacturing_rl3: "Productie-proof-of-concept ontwikkeld",
  manufacturing_rl4:
    "Vermogen om de technologie in een laboratoriumomgeving te produceren",
  manufacturing_rl5:
    "Vermogen om prototypecomponenten in een productie-relevante omgeving te produceren",
  manufacturing_rl6:
    "Vermogen om een prototypesysteem of subsysteem in een productie-relevante omgeving te produceren",
  manufacturing_rl7:
    "Vermogen om systemen, subsystemen of componenten in een productie-representatieve omgeving te produceren",
  manufacturing_rl8:
    "Pilotlijncapaciteit aangetoond. Klaar om te beginnen met productie op lage schaal",
  manufacturing_rl9:
    "Productie op lage schaal aangetoond. Capaciteit aanwezig om te beginnen met volledige productie",
  commercialisation_rl1: "Onderzoek en basishypothese",
  commercialisation_rl2: "Marktanalyse",
  commercialisation_rl3: "Validatie van technologie-toepassing en markt",
  commercialisation_rl4: "Waardepropositie",
  commercialisation_rl5: "Productontwikkeling en marktafstemming",
  commercialisation_rl6:
    "Optimalisatie van product/oplossing en IP-bescherming",
  commercialisation_rl7: "Technische en commerciële validatie",
  commercialisation_rl8: "Commercialiseringsstrategie en marktintroductie",
  commercialisation_rl9: "Volledige lancering en licentie-inkomsten",
  security_rl1: "Beveiligingsoverweging",
  security_rl2: "Ontwikkeling van beveiligingsconcept",
  security_rl3: "Security by design",
  security_rl4: "Voorbereiding van beveiligingsmaatregelen en -functies",
  security_rl5: "Eenvoudige beveiligingsvalidatie",
  security_rl6: "Sequentiële beveiligingsdemonstratie",
  security_rl7: "Complexe beveiligingsdemonstraties",
  security_rl8: "Laatste beveiligingsvalidatie en voorbereiding vóór release",
  security_rl9: "Initiële operationele beveiliging",
  security_rl10: "Goed gevestigde/betrouwbare beveiliging",
  legal_privacy_ethical_rl1:
    "Beheersing van juridische, ethische en privacykwesties: het systeem heeft beheersmechanismen voor verantwoording geïmplementeerd en, indien van toepassing, standaardbenchmarks doorstaan en certificering verkregen",
  legal_privacy_ethical_rl2:
    "Ethische spanningen aangepakt via ethics-by-design: de juridische, ethische en privacy-overwegingen van het systeem zijn zo ontworpen dat ze onderling verenigbaar zijn. Ethische spanningen zijn aangepakt, zodat verbetering van het ene aspect geen negatieve invloed heeft op een ander aspect",
  legal_privacy_ethical_rl3:
    "Gekarakteriseerde juridische, ethische en privacy-interacties: de interacties tussen verschillende ethische en privacy-overwegingen zijn gekarakteriseerd",
  legal_privacy_ethical_rl4:
    "Geïdentificeerde juridische, ethische en privacykwesties: de ethische en privacy-overwegingen die door het systeem worden opgeworpen, zijn geïdentificeerd en voorzien",
  sol_linked_caps: "Gekoppelde capaciteiten (met tekortkomingen)",
  sol_addressed_gaps: "Aangesproken capaciteitstekortkomingen",
  sol_no_gaps:
    "Er zijn nog geen capaciteitstekortkomingen vastgesteld. Ga naar Stap 1 om capaciteiten te beoordelen.",
  sol_compliance_title: "Compliancecontroles",
  sol_status: "Status",
  sol_pass: "Voldoet",
  sol_partial: "Gedeeltelijk",
  sol_fail: "Voldoet niet",
  sol_na: "N.v.t.",
  sol_not_applicable: "Niet van toepassing",
  sol_user_needs_title: "Gebruikersbehoeften",
  sol_operational_needs_title: "Operationele behoeften",
  sol_organisational_needs_title: "Organisatorische behoeften",
  sol_expected_impact_title: "Verwachte impact",
  sol_question: "Vraag",
  sol_response: "Antwoord",
  // User Needs questions
  UN01: "Is de oplossing eenvoudig te gebruiken?",
  UN02: "Werkt de oplossing waarschijnlijk voldoende onder druk? Met inbegrip van robuustheid en betrouwbaarheid.",
  UN03: "Wordt de oplossing waarschijnlijk geaccepteerd door gebruikers?",
  UN04: "Ondersteunt de oplossing waarschijnlijk de begrip van gebruikers?",
  UN05: "Ondersteunt de oplossing waarschijnlijk de verklarbaarheid voor gebruikers?",
  UN06: "Verbeterd de oplossing waarschijnlijk de efficiëntie van gebruikers?",
  UN07: "Verbeterd de oplossing waarschijnlijk de effectiviteit voor gebruikers?",
  UN08: "Biedt de oplossing waarschijnlijk extra kennis?",
  UN09: "Produceert de oplossing waarschijnlijk consistent positieve interventies en/of resultaten?",
  // Operational Needs questions
  ON01: "Vereist de oplossing waarschijnlijk uitgebreide (her-)training?",
  ON02: "Vereist de oplossing waarschijnlijk overmatig onderhoud en ondersteuning?",
  ON03: "Is de oplossing waarschijnlijk compatibel met uw werkmethode/SoP?",
  ON04: "Is de oplossing interoperabel?",
  ON05: "Is de oplossing waarschijnlijk aanpasbaar en overdraagbaar op uw werksituaties?",
  ON06: "Ondersteunt de oplossing waarschijnlijk de gezondheid en veiligheid vanresponders?",
  ON07: "Bereikt de oplossing waarschijnlijk de beoogde doelgroep?",
  ON08: "Biedt de oplossing waarschijnlijk verbeterde operationele efficiëntie?",
  ON09: "Biedt de oplossing waarschijnlijk verbeterde operationele effectiviteit?",
  // Organisational Needs questions
  OG01: "Heeft de oplossing waarschijnlijk een positieve kost-batenverhouding?",
  OG02: "Is de oplossing haalbaar? Inbegrepen technologisch, economisch, juridisch, operationeel en schema's.",
  OG03: "Is de oplossing waarschijnlijk compatibel met uw organisatiedultur?",
  OG04: "Is de oplossing waarschijnlijk compatibel met uw organisatiemandaat?",
  OG05: "Is de oplossing waarschijnlijk compatibel met de prioriteiten van CM-bestuur?",
  OG06: "Ondersteunt het gebruik van de oplossing uw reputatie onder het publiek?",
  OG07: "Helpt het gebruik van de oplossing de gemeenschapsrelaties te verbeteren?",
  // Expected Impact questions
  EI01: "Wordt de oplossing toegepast in de context van humaine gezondheidszorg?",
  EI02: "Bevat de oplossing de verwerking van persoonlijke gegevens?",
  EI03: "Heeft de oplossing waarschijnlijk een negatieve impact op de rechten en vrijheden van individuen en groepen? Bv. privacy, waardigheid, autonomie, solidariteit.",
  EI04: "Heeft de oplossing waarschijnlijk een negatieve impact op sociaal rechtvaardigheid en gelijkheid?",
  EI05: "Heeft de oplossing waarschijnlijk een negatieve impact op het welzijn van individuen of groepen?",
  EI06: "Verhoogt de oplossing waarschijnlijk de kwetsbaarheid van individuen of groepen?",
  EI07: "Is de oplossing waarschijnlijk een potentieel veiligheidsrisico?",
  EI08: "Heeft de oplossing waarschijnlijk een negatieve impact op het milieu?",
  EI09: "Is er SIGNIFICANTE onzekerheid over de juridische, ethische en maatschappelijke impact van het gebruik van de oplossing?",
  // Compliance checks
  CC01: "(Cyber) Beveiliging",
  CC02: "Interoperabiliteit",
  CC03: "AI-wetgeving",
  CC04: "Community betrokkenheid",
  CC05: "GDPR",
  CC06: "Fundamentele rechten",
  CC07: "Duurzame ontwikkelingsdoelen",
  CC08: "Nationaal niveau crisisbestrijdingsprioriteiten",
  CC09: "Sector-specifieke normen",
  CC10: "Sector-specifieke wetten & regelgeving",
  cap_add_from_ref: "Capaciteiten toevoegen uit referentiemodel",
  cap_all_selected:
    "Alle referentiecapaciteiten zijn al aan uw sessie toegevoegd.",
  cap_add_selected: "Geselecteerde capaciteiten toevoegen",
  cap_ref_panel_title: "Beschikbare capaciteiten (DASF referentiemodel)",
  collapse: "Inklappen",
  step0_abbr: "Stap 0: I&V",
  step0_desc:
    "Identificeer relevante gevarentypen voor uw beoordelingscontext.",
  step1_abbr: "Stap 1: BLA",
  step1_desc:
    "Beoordeel capaciteiten, identificeer lacunes en verbeterbehoeften.",
  step2_abbr: "Stap 2: OB",
  step2_desc: "Evalueer oplossingen voor geïdentificeerde capaciteitstekorten.",
  step3_abbr: "Stap 3: RK",
  step3_desc: "Plan implementatieroutekaart en toezeggingen.",
  landing_attribution:
    "DIREKTION heeft financiering ontvangen van het Horizon Europe-onderzoeks- en innovatieprogramma van de Europese Unie onder subsidieovereenkomst nr. 101121249.",
  landing_developed_by: "Ontwikkeld door",
  landing_as_part_of: "als onderdeel van het",
  landing_project: "project.",
  dasf_purpose_title: "Doel van het DASF",
  dasf_purpose_p1:
    "Het DIREKTION Assessment and Screening Framework (DASF) is een kernmethode ontwikkeld binnen het DIREKTION-project om een transparant en onpartijdig screenings- en beoordelingsproces te ondersteunen.",
  dasf_purpose_offers: "Het DASF-framework biedt een stapsgewijze methode om:",
  dasf_purpose_item1: "Capaciteitstekorten te identificeren en aan te pakken",
  dasf_purpose_item2:
    "Systematische screening van technologieën en oplossingen te implementeren",
  dasf_purpose_item3: "Een routekaart op te stellen",
  dasf_purpose_p2:
    "Het DASF biedt de basis voor een duurzaam proces voor onderzoeksprogrammering, zodat hulpverleners en belanghebbenden toegang hebben tot de meest effectieve en actuele hulpmiddelen voor rampenparaatheid en -respons. De complete set is bedoeld om regelmatig te worden uitgevoerd — bijvoorbeeld eens per jaar of eens per vier jaar — om een bijgewerkt inzicht te krijgen in de meest actuele capaciteitsbehoeften, capaciteitstekorten, potentiële oplossingen en om de routekaart voor bijvoorbeeld EU- of nationale onderzoeksmogelijkheden regelmatig bij te werken.",
  landing_assessment_process: "Beoordelingsproces",
  landing_video_tutorial: "Bekijk de videotutorial op YouTube",
  landing_funded_by: "Gefinancierd door de Europese Unie",
  landing_trilateral_attribution:
    "Voor de totstandkoming van deze tool is gebruikgemaakt van essentiële bijdragen van Trilateral Research, zoals ontwikkeld in DIREKTION D1.2.",
  delete_session_confirm: "Sessie verwijderen: {name}?",
  delete_session_warning:
    "Dit kan niet ongedaan worden gemaakt. Weet u het zeker?",
  // Hazard types (keys = hazard IDs)
  N01: "Aardbeving",
  N02: "Tsunami",
  N03: "Vulkaanuitbarsting",
  N04: "Aardverschuiving / Lawine",
  N05: "Overstroming",
  N06: "Plotselinge overstroming",
  N07: "Storm / Orkaan / Tornado",
  N08: "Bosbrand / Natuurbrand",
  N09: "Extreme temperatuur (hitte/kou)",
  N10: "Droogte",
  N11: "Epidemie / Pandemie",
  N12: "Dierziekte-uitbraak",
  N13: "Insectenplaag",
  T01: "Industrieel ongeluk (CBRN)",
  T02: "Nucleair / Radiologisch incident",
  T03: "Verkeersongeluk (lucht)",
  T04: "Verkeersongeluk (spoor)",
  T05: "Verkeersongeluk (weg)",
  T06: "Verkeersongeluk (maritiem)",
  T07: "Pijpleiding / Gasexplosie",
  T08: "Instorting gebouw / constructie",
  T09: "Dijkdoorbraak / Damfalen",
  T10: "Stroomuitval / Netuitval",
  T11: "Uitval telecommunicatie",
  T12: "Verontreiniging drinkwater",
  T13: "Gevaarlijke stoffen lekkage",
  A01: "Terroristische aanslag (explosief)",
  A02: "Terroristische aanslag (CBRN)",
  A03: "Cyberaanval",
  A04: "Gewapende aanval / Schietpartij",
  A05: "Sabotage kritieke infrastructuur",
  A06: "Gijzeling / Ontvoering",
  A07: "Burgerlijke onrust / Rellen",
  A08: "Maritieme piraterij / Kaping",
  A09: "Droneaanval",
  A10: "Hybride dreiging",
  A11: "Desinformatiecampagne",
  A12: "Verstoring toeleveringsketen (opzettelijk)",
  A13: "Brandstichting",
  // Capability categories (keys = category IDs)
  "Cat-01": "Mitigatie / Preventie",
  "Cat-02": "Voorbereiding",
  "Cat-03": "Respons",
  "Cat-04": "Herstel",
  // Capability subcategories (keys = subcategory IDs)
  "Mit-01": "Risicobeoordeling",
  "Mit-02": "Blootstellingsreductie",
  "Mit-03": "Ondersteuning mitigatie",
  "Prep-01": "Capaciteitsontwikkeling",
  "Prep-02": "Monitoring",
  "Prep-03": "Ondersteuning voorbereiding",
  "Rsp-01": "Incident onderdrukken",
  "Rsp-02": "Reddingsoperaties",
  "Rsp-03": "Beveiliging / Rechtshandhaving",
  "Rsp-04": "Spoedeisende Gezondheidszorg",
  "Rsp-05": "Communicatie naar de samenleving",
  "Rsp-06": "Bescherming bevolking / dieren",
  "Rsp-07": "Ruiming rampgebied",
  "Rsp-08": "Basisbehoeftenvoorziening",
  "Rsp-09": "Ondersteuning respons",
  "Rec-01": "Humanitair herstel",
  "Rec-02": "Milieuherstel",
  "Rec-03": "Economisch herstel",
  "Rec-04": "Herstel infrastructuur",
  "Rec-05": "Ondersteuning herstel",
  // Capabilities (keys = capability IDs)
  "Mit-RA-01": "Risicoidentificatie",
  "Mit-RA-02": "Risicoanalyse",
  "Mit-RA-03": "Risicoevaluatie",
  "Mit-ER-01": "Eigendomsbescherming",
  "Mit-ER-02": "Bescherming natuurlijke hulpbronnen",
  "Mit-ER-03": "Bewustwording vergroten",
  "Mit-MS-01": "Trendanalyse",
  "Mit-MS-02": "Monitoring en evaluatie",
  "Prep-CD-01": "Respons- en herstelplanning",
  "Prep-CD-02": "Training",
  "Prep-CD-03": "Risicocommunicatie",
  "Prep-MO-01": "Detectie",
  "Prep-MO-02": "Alarmering",
  "Prep-PS-01": "Personeelsbeheer",
  "Prep-PS-02": "Middelenbeheer",
  "Prep-PS-03": "Samenwerkingsverbanden opzetten",
  "Prep-EH-04": "Psychologische zorg",
  "Resp-SI-01": "Brandbestrijding - Infrastructuur",
  "Resp-SI-02": "Brandbestrijding - Natuur",
  "Resp-SI-03": "Waterbeheersing",
  "Resp-SI04": "Gevaarlijke stoffen beheersing (CBRN-E)",
  "Resp-RO-01": "Zoek- en reddingsoperaties (SAR)",
  "Resp-RO-02": "Behandeling slachtoffers ter plaatse",
  "Resp-RO-03": "Transport van slachtoffers",
  "Resp-SL-01": "Beveiligen locaties / personen",
  "Resp-SL-02": "Identificatie van personen",
  "Resp-SL-03": "Forensisch onderzoek",
  "Resp-SL-04": "Handhaving openbare orde",
  "Resp-SL-05": "Verkeersmanagement",
  "Resp-EH-01": "Spoedeisende zorg - Ziekenhuizen",
  "Resp-EH-02": "Quarantaine",
  "Resp-EH-03": "Massale volksgezondheid",
  "Resp-CS-01": "Waarschuwing",
  "Resp-CS-02": "Crisiscommunicatie",
  "Resp-SF-01": "Evacuatie",
  "Resp-SF-02": "Opvang",
  "Resp-SF-03": "Hereniging",
  "Resp-DA-01": "Puin ruimen",
  "Resp-DA-02": "Decontaminatie van objecten",
  "Resp-DA-03": "Afwateren / Pompen",
  "Resp-DA-04": "Ruiming dieren",
  "Resp-BN-01": "Drinkwatervoorziening",
  "Resp-BN-02": "Voedselvoorziening",
  "Resp-BN-03": "Energievoorziening",
  "Resp-BN-04": "Voorziening ICT / Telecom",
  "Resp-BN-05": "Sanitaire voorzieningen",
  "Resp-RS-01": "Commando, Controle en Coördinatie",
  "Resp-RS-02": "Situatiebeoordeling",
  "Resp-RS-03": "Informatiebeheer",
  "Resp-RS-04": "Monitoring / Dataverzameling",
  "Resp-RS-05": "Operationele ondersteuning ter plaatse",
  "Resp-RS-06": "Logistiek",
  "Rec-HR-01": "Volksgezondheid en veiligheid",
  "Rec-HR-02": "Voedsel en opvang",
  "Rec-ER-01": "Afvalbeheer",
  "Rec-ER-02": "Herstel leefgebieden",
  "Rec-EC-01": "Bedrijfsherstel",
  "Rec-EC-02": "Financieel herstel",
  "Rec-RI-01": "Herstel transport",
  "Rec-RI-02": "Herstel nutsvoorzieningen",
  "Rec-RS-01": "Herstelorganisatie opzetten",
  "Rec-RS-02": "Herstelplan opstellen",
  // mainTasks labels and descriptions
  "Goal-01": "Incidenten voorkomen",
  "Goal-01_desc": "Rampen en crisissituaties voorkomen.",
  "Goal-02": "Verliezen beperken",
  "Goal-02_desc": "Verliezen door gevaren reduceren of voorkomen.",
  "Goal-03": "Slachtoffers helpen",
  "Goal-03_desc":
    "Snelle en effectieve hulpverlening aan slachtoffers waarborgen.",
  "Goal-04": "Adequaat herstel",
  "Goal-04_desc": "Zorgen voor een snel en effectief herstel.",
  // Stakeholder types (TO-01 through TO-09)
  "TO-01": "Brandweer / Civiele bescherming",
  "TO-02": "Politie",
  "TO-03": "Noodgezondheidszorg",
  "TO-04": "Defensie",
  "TO-05": "Commandocentrum",
  "TO-06": "Overheden",
  "TO-07": "Kritieke infrastructuur",
  "TO-08": "NGO",
  "TO-09": "Overige",
  // Stakeholders (SH-01 through SH-12)
  "SH-01": "Brandweer/Civiele bescherming",
  "SH-02": "Politie",
  "SH-03": "Noodgezondheidszorg",
  "SH-04": "Zoek- en reddingsdienst",
  "SH-05": "Commando of Dispatch centrum (112)",
  "SH-06": "Overheden (ministeries, gemeenten)",
  "SH-07": "Defensie",
  "SH-08": "Openbare diensten",
  "SH-09": "Kustwacht of Grensbeveiliging",
  "SH-10": "Kritieke infrastructuur operator",
  "SH-11": "NGO",
  "SH-12": "Overige (te beschrijven)",
  // taskScale labels
  "Imp-1": "Geen/Zeer laag",
  "Imp-2": "Laag",
  "Imp-3": "Gemiddeld",
  "Imp-4": "Vrij hoog",
  "Imp-5": "Zeer hoog",
  // performanceAspects labels and descriptions
  "PA-1": "Effectiviteit",
  "PA-1_desc": "Kwaliteit van de resultaten, tijdigheid, uithoudingsvermogen.",
  "PA-2": "Veiligheid/Beveiliging van professionals",
  "PA-2_desc": "Fysieke en mentale veiligheid van betrokken personeel.",
  "PA-3": "Efficiëntie",
  "PA-3_desc": "Verhouding tussen kosten en resultaten.",
  // performanceScale labels
  "PSc-1": "Slecht",
  "PSc-2": "Onvoldoende",
  "PSc-3": "Matig",
  "PSc-4": "Voldoende",
  "PSc-5": "Goed",
  // mainGaps labels and descriptions
  "Nat-01": "Technologisch",
  "Nat-01_desc":
    "Bijv. Sensortechnologieën, commando en controle, communicatie en coördinatie, ICT.",
  "Nat-02": "Menselijk",
  "Nat-02_desc":
    "Bijv. Hoeveelheid personeel, competentie van personeel, training en opleiding.",
  "Nat-03": "Organisatorisch",
  "Nat-03_desc":
    "Bijv. Procedures, organisatiestructuur, financiële aspecten, overeenkomsten.",
  "Nat-04": "Regelgevend",
  "Nat-04_desc": "Bijv. Juridische aspecten, formele standaardisatieaspecten.",
  // gapScale labels
  "Kn-01": "Onbekend",
  "Kn-02": "Nee",
  "Kn-03": "Ja",
  // assessmentScale labels
  "ASc-01": "Zeer laag",
  "ASc-02": "Laag",
  "ASc-03": "Matig",
  "ASc-04": "Hoog",
  "ASc-05": "Zeer hoog",
  // Category descriptions
  "Cat-01_desc":
    "Doelstelling: Maatregelen nemen om de kans te beperken en de impact van een incident, ramp of crisis te verminderen.",
  "Cat-02_desc":
    "Doelstelling: De organisatiestructuur en capaciteiten ontwikkelen en onderhouden voor respons- en herstelactiviteiten.",
  "Cat-03_desc": "Doelstelling: Levens redden en nadelige effecten beperken.",
  "Cat-04_desc":
    "Doelstelling: Het normale leven op een efficiënte manier herbouwen en herstellen.",
  // Subcategory descriptions
  "Mit-01_desc": "Identificatie, analyse en evaluatie van risico's.",
  "Mit-02_desc":
    "Bescherming van eigendommen, natuurlijke hulpbronnen en de samenleving tegen gevaren.",
  "Mit-03_desc": "Capaciteiten ter ondersteuning van Mitigatie / Preventie.",
  "Prep-01_desc":
    "Proces van het ontwikkelen en onderhouden van vereiste crisisbeheercapaciteiten.",
  "Prep-02_desc":
    "De status van een omgeving of situatie bepalen om detectie van incidenten mogelijk te maken.",
  "Prep-03_desc": "Capaciteiten ter ondersteuning van capaciteitsontwikkeling.",
  "Rsp-01_desc":
    "On-site activiteiten om de oorzaak van de ramp te stoppen of in te dammen.",
  "Rsp-02_desc": "On-site activiteiten om levens te redden.",
  "Rsp-03_desc":
    "Beveiligen van gebieden/personen, identificatie van personen, forensisch onderzoek.",
  "Rsp-04_desc": "Off-site activiteiten om levens te redden.",
  "Rsp-05_desc": "Waarschuwing en crisiscommunicatie.",
  "Rsp-06_desc": "Gecontroleerde evacuatie van personen en/of dieren.",
  "Rsp-07_desc":
    "Toegankelijkheid en veiligheid in het getroffen gebied waarborgen.",
  "Rsp-08_desc":
    "Levering en/of herstel van basisproducten en diensten van vitaal belang.",
  "Rsp-09_desc":
    "Capaciteiten om één of meer andere responsecapaciteiten mogelijk te maken.",
  "Rec-01_desc":
    "Verstrekking van volksgezondheids- en veiligheidsdiensten en onderdak.",
  "Rec-02_desc": "Opruiming van vervuiling en decontaminatie.",
  "Rec-03_desc": "Economisch en zakelijk herstel.",
  "Rec-04_desc": "Herstel van transportroutes en essentiële diensten.",
  "Rec-05_desc":
    "Capaciteiten die nodig zijn voor een goed gecoördineerd herstel.",
  // Capability descriptions
  "Mit-RA-01_desc":
    "Proces van het vinden, herkennen en beschrijven van risico's.",
  "Mit-RA-02_desc":
    "Proces om de aard van het risico te begrijpen en het risiconiveau te bepalen.",
  "Mit-RA-03_desc":
    "Proces van het vergelijken van risicoanalyseresultaten met risicocriteria om te bepalen of het risico aanvaardbaar is.",
  "Mit-ER-01_desc":
    "Bescherming van eigendommen (inclusief kritieke infrastructuur).",
  "Mit-ER-02_desc":
    "Acties die verliezen door gevaren minimaliseren en de functies van natuurlijke systemen bewaren of herstellen.",
  "Mit-ER-03_desc":
    "Publieke voorlichting en bewustwording over gevaren en manieren om ze te beperken.",
  "Mit-MS-01_desc": "Onderzoek naar de ontwikkeling van risico's.",
  "Mit-MS-02_desc":
    "Zorgen dat beheersmaatregelen effectief en efficiënt zijn en aanvullende informatie verkrijgen voor risicobeoordeling.",
  "Prep-CD-01_desc":
    "Procedures en informatie ontwikkelen, compileren en onderhouden voor gebruik bij een incident.",
  "Prep-CD-02_desc":
    "Activiteiten om kennis, vaardigheden en bekwaamheden voor rampenrespons te ontwikkelen.",
  "Prep-CD-03_desc":
    "Communiceren en instrueren van het publiek over crisisvoorbereiding en gedrag tijdens een crisis.",
  "Prep-MO-01_desc": "Detectie van omstandigheden die afwijken van normaal.",
  "Prep-MO-02_desc":
    "Personeel alarmeren bij aanwezigheid van een incident en beheeracties initiëren.",
  "Prep-PS-01_desc":
    "Activiteiten om voldoende en geschoold personeel te bieden voor respons- en hersteltaken.",
  "Prep-PS-02_desc":
    "Activiteiten om uitrusting, gereedschappen, ICT en andere middelen te bieden voor respons en herstel.",
  "Prep-PS-03_desc":
    "Internationale samenwerkingsverbanden opzetten tussen hulpdiensten en derden.",
  "Prep-EH-04_desc":
    "Psychologische gezondheidszorg voor slachtoffers, verwanten en anderen die worden getroffen.",
  "Resp-SI-01_desc":
    "Brandbestrijding in gebouwen, bebouwde gebieden of infrastructuur.",
  "Resp-SI-02_desc": "Brandbestrijding in natuurlijke omgevingen.",
  "Resp-SI-03_desc":
    "Waterbeheer bij overstromingen door dijkdoorbraak of zware regenval.",
  "Resp-SI04_desc":
    "Stoppen van lekkage van gevaarlijke stoffen, inclusief inperking (CBRN-E incidenten).",
  "Resp-RO-01_desc": "Zoek- en reddingsoperaties.",
  "Resp-RO-02_desc": "Triage, decontaminatie en stabilisatie van slachtoffers.",
  "Resp-RO-03_desc":
    "Ambulancetransport naar veilige gebieden of ziekenhuizen.",
  "Resp-SL-01_desc":
    "Gebieden, infrastructuur en personen beschermen tegen onbetrokkenen.",
  "Resp-SL-02_desc": "Identificatie van slachtoffers.",
  "Resp-SL-03_desc":
    "Forensische activiteiten om de oorzaak van het incident te onderzoeken en bewijs veilig te stellen.",
  "Resp-SL-04_desc": "Oproerbeheersing, etc.",
  "Resp-SL-05_desc": "Verkeersregeling in en uit het getroffen gebied.",
  "Resp-EH-01_desc": "Gezondheidsdiensten in reguliere en/of veldhospitalen.",
  "Resp-EH-02_desc":
    "Isolatie van potentieel besmettelijke personen/slachtoffers.",
  "Resp-EH-03_desc":
    "Massale profylaxe of vaccinatie bij een nucleair incident of pandemie.",
  "Resp-CS-01_desc":
    "De samenleving in de bedreigde zone waarschuwen met tijdige en adequate informatie.",
  "Resp-CS-02_desc":
    "Informatie verstrekken over de ramp aan de samenleving, inclusief vrijwilligersbeheer.",
  "Resp-SF-01_desc":
    "Gecontroleerde evacuatie van personen en dieren uit een bepaald gebied of gebouw.",
  "Resp-SF-02_desc":
    "Opvangvoorzieningen voor evacuees, inclusief voeding en sanitair.",
  "Resp-SF-03_desc": "Hereniging van evacuees met hun verwanten.",
  "Resp-DA-01_desc": "Verwijdering van puin en/of besmet materiaal.",
  "Resp-DA-02_desc":
    "Decontaminatie van besmette gebieden, infrastructuur en/of voertuigen.",
  "Resp-DA-03_desc":
    "Afwateren en pompen van overstroomde gebieden of infrastructuur.",
  "Resp-DA-04_desc": "Vernietiging van mogelijk geïnfecteerde dieren.",
  "Resp-BN-01_desc": "Herstel of tijdelijke voorziening van drinkwater.",
  "Resp-BN-02_desc": "Tijdelijke voorziening van voedsel.",
  "Resp-BN-03_desc":
    "Herstel van elektriciteits-/gaslevering of tijdelijke alternatieve energie.",
  "Resp-BN-04_desc":
    "Herstel of tijdelijke levering van ICT en telecommunicatie.",
  "Resp-BN-05_desc": "Sanitair herstellen of tijdelijke oplossingen bieden.",
  "Resp-RS-01_desc":
    "Besluitvorming, planning en taakopdracht op coördinatie- en commandoniveau bij rampenbeheersing.",
  "Resp-RS-02_desc":
    "Ontwikkeling van operationele informatie door verrijking van verzamelde data, inclusief gemeenschappelijk operationeel beeld.",
  "Resp-RS-03_desc":
    "Opslaan en delen van informatie zoals verzamelde data, beoordelingen en genomen beslissingen.",
  "Resp-RS-04_desc":
    "Verzameling van data door fysieke monitoring (surveillance) en data-mining.",
  "Resp-RS-05_desc":
    "Levering van basisdiensten aan first responders ter plaatse om responsactiviteiten mogelijk te maken.",
  "Resp-RS-06_desc":
    "Transport van personeel en materieel ter ondersteuning van langdurige rampenresponsoperaties.",
  "Rec-HR-01_desc":
    "Verstrekking van volksgezondheids- en veiligheidsdiensten voor ontheemden.",
  "Rec-HR-02_desc": "Verstrekking van voedsel en onderdak voor ontheemden.",
  "Rec-ER-01_desc":
    "Opruiming van grootschalige vervuiling en decontaminatie, en afvalverwerking.",
  "Rec-ER-02_desc": "Herstel van natuurlijke hulpbronnen en leefgebieden.",
  "Rec-EC-01_desc":
    "Bedrijfsherstel van winkels en industrie die door de ramp zijn getroffen.",
  "Rec-EC-02_desc": "Herstel van financiële impact op autoriteiten.",
  "Rec-RI-01_desc":
    "Herstel van transportroutes (weg, spoor, water, lucht, pijpleidingen).",
  "Rec-RI-02_desc":
    "Herstel van onderbroken nutsvoorzieningen en andere essentiële diensten.",
  "Rec-RS-01_desc":
    "Opzetten van herstelorganisatiestructuur voor zowel kortetermijn- als langetermijnherstel.",
  "Rec-RS-02_desc":
    "Bepaling en uitvoering van herstelprogramma op basis van impactbeoordeling.",
  // Overview UI
  manage_capabilities: "Capaciteiten selecteren",
  select_capabilities_instr:
    "Selecteer de capaciteiten die u wilt beoordelen op tekortkomingen.",
  // Context drawer
  drawer_hazards: "Gevaren",
  drawer_gaps: "Tekortkomingen",
  drawer_solutions: "Oplossingen",
  drawer_roadmap: "Routekaart",
  drawer_capabilities: "Capaciteiten",
  drawer_solution: "Oplossing",
  drawer_with_gaps: "met tekortkomingen",
  drawer_no_linked_caps: "Geen gekoppelde capaciteiten",
  drawer_add_to_roadmap: "Voeg toe aan routekaart →",
  drawer_go_to_solutions: "Ga naar oplossingen →",
  drawer_go_to_roadmap: "Ga naar routekaart →",
  drawer_none: "Geen",
  drawer_relevant_hazards: "Relevante gevaren",
  // Assessment action priority
  action_priority: "Actieprioriteit",
  action_priority_instr:
    "Beoordeel uw bereidheid om aan de verbetering van deze capaciteit te werken (1 = laag, 5 = urgent)",
  action_priority_label_1: "Nu niet",
  action_priority_label_3: "Misschien",
  action_priority_label_5: "Urgent",
  // Assessment navigation
  prev_cap: "Vorige",
  next_cap: "Volgende",
  about_markdown: `#### DIREKTION Assessment & Screening Framework (DASF)

De DASF-toolset ondersteunt het systematische beoordelings- en screeningproces voor rampenbestrijding. Het biedt een gestructureerde aanpak in 4 stappen:

1. **Initiatie & Voorbereiding (I&P)**: Identificeer relevante typen gevaren en definieer de scope van de beoordeling.
2. **Behoeften & Lacunes Beoordeling (NGA)**: Beoordeel capaciteiten in de rampenbestrijdingscyclus, identificeer lacunes en verbeterbehoeften.
3. **Oplossingsbeoordeling (SA)**: Evalueer potentiële oplossingen voor geïdentificeerde lacunes, inclusief compliance, gebruikersbehoeften en impactbeoordeling.
4. **Routekaart (RM)**: Plan implementatietijdlijnen en toezeggingen voor geselecteerde oplossingen.

##### Aan de slag

- Maak een nieuwe of open een bestaande beoordelingssessie vanaf de startpagina
- Navigeer door de 4 stappen met de werkbalkpictogrammen
- Schakel tussen Gebruiker- en Redacteurrol met de selector hieronder

##### Rollen

- **Gewone gebruiker**: Kan beoordelingen invullen en resultaten bekijken
- **Moderator**: Kan de frameworkconfiguratie bewerken (gevarentypen, capaciteiten, stakeholders)
- **Beheerder**: Kan beoordelingsschalen en instellingen wijzigen

##### Achtergrond

Dit project heeft financiering ontvangen van het Horizon 2020-programma voor onderzoek en innovatie van de Europese Unie. Ontwikkeld door TNO als onderdeel van het [DIREKTION](https://www.direktion-network.org)-project.`,

  // ── Collaboration (EN fallback) ────────────────────────────────────────────
  COLLABORATE: {
    TITLE: "Collaborate",
    ROUTE: "/collaborate",
    PAGE: "Collaboration",
  },
  FACILITATOR: "Facilitator",
  collab_page_title: "Collaboration",
  collab_send_invite: "Send Invite",
  collab_load_patch: "Load Patch",
  collab_mode_ca: "Capability Assessment",
  collab_mode_sc: "Solution Creation",
  collab_mode_sa: "Solution Assessment",
  collab_select_modes: "Select collaboration modes",
  collab_your_name: "Your name",
  collab_your_email: "Your email",
  collab_facilitator_name: "Facilitator name",
  collab_facilitator_email: "Facilitator email",
  collab_custom_message: "Optional message",
  collab_generate_link: "Send Invite by Email",
  collab_done: "Klaar - Resultaten verzenden",
  collab_patch_loaded: "Patch loaded",
  collab_patches_count: {
    1: "1 patch received",
    n: "{n} patches received",
  },
  collab_hash_mismatch:
    "Warning: This patch was created from a different version of the model.",
  collab_session_mismatch:
    "This patch belongs to a different session and cannot be loaded.",
  collab_duplicate_ignored: "Duplicate patch ignored (already loaded).",
  collab_aggregated_results: "Aggregated Results",
  collab_apply_results: "Apply to model",
  collab_no_patches: "No patches received yet.",
  collab_invited_by: "You have been invited by {name} ({email}) to contribute.",
  collab_paste_patch: "Paste a patch link here",
  collab_load_patch_btn: "Load",
  collab_remove_patch: "Remove",
  collab_contributor: "Contributor",
  collab_received_at: "Received at",
  collab_avg_action_priority: "Avg. action priority",
  collab_task_items: "Task importance answers",
  collab_perf_items: "Performance answers",
  collab_gap_items: "Gap answers",
  collab_all_values: "All values",
  collab_avg_value: "Average",
  collab_invite_subject: "Invitation to collaborate on capability assessment",
  collab_invite_body:
    "Dear colleague,\n\nYou are invited to contribute to a capability assessment for {facilitatorName}.\n\nPlease click the link below to open the assessment tool and fill in your responses. When you are done, click the 'Done' button to send your results back.\n\nThis link is valid for one-time use — please do not share it.\n\nKind regards,\n{facilitatorName}",
  collab_patch_subject: "Capability assessment completed",
  collab_patch_body:
    "Dear {facilitatorName},\n\nI have completed the capability assessment you sent me.\n\nPlease click the link below to load my responses into the tool.\n\nKind regards,\n{userName}",
  // ── End Collaboration ───────────────────────────────────────────────────────
};
